(function () {
  "use strict";
  var doc = document;
  var decks = [];
  function prune() {
    for (var i = decks.length - 1; i >= 0; i -= 1) {
      if (!doc.contains(decks[i])) decks.splice(i, 1);
    }
  }
  function build(root) {
    var track = root.querySelector(".xg-scroller");
    if (!track) return;
    var cards = [];
    for (var c = track.firstElementChild; c; c = c.nextElementSibling) {
      cards.push(c);
    }
    if (cards.length < 2) return;
    var nav = root.querySelector("[data-xg-deck-nav]");
    var count = root.querySelector("[data-xg-deck-count]");
    var prev = root.querySelector("[data-xg-deck-prev]");
    var next = root.querySelector("[data-xg-deck-next]");
    var index = root.querySelector("[data-xg-deck-index]");
    var jumps = root.querySelectorAll("[data-xg-deck-to]");
    var n = cards.length;
    var at = 0;
    var dragging = false;
    var moved = false;
    var swipeable = false;
    var startX = 0;
    var startY = 0;
    var pointer = null;
    function paint() {
      for (var i = 0; i < n; i += 1) {
        var d = (i - at + n) % n;
        cards[i].style.setProperty("--xg-deck-d", String(d));
        cards[i].style.removeProperty("--xg-deck-dx");
        if (d === 0) cards[i].setAttribute("data-xg-deck-at", "");
        else cards[i].removeAttribute("data-xg-deck-at");
      }
      if (count) count.textContent = at + 1 + " of " + n;
      for (var j = 0; j < jumps.length; j += 1) {
        if (j === at) jumps[j].setAttribute("aria-current", "true");
        else jumps[j].removeAttribute("aria-current");
      }
    }
    function to(i) {
      if (i < 0 || i >= n || i === at) return;
      at = i;
      paint();
    }
    function go(step) {
      at = (at + step + n) % n;
      paint();
    }
    root.addEventListener("click", function (event) {
      if (event.detail > 1) return;
      if (event.target.closest("a, button, summary, input, select, textarea")) {
        return;
      }
      if (moved) { moved = false; return; }
      go(1);
    });
    root.addEventListener("pointerdown", function (event) {
      if (!event.isPrimary) return;
      if (event.target.closest("a, button, summary, input, select, textarea")) {
        return;
      }
      pointer = event.pointerId;
      swipeable = event.pointerType !== "mouse";
      startX = event.clientX;
      startY = event.clientY;
      dragging = false;
      moved = false;
    });
    root.addEventListener("pointermove", function (event) {
      if (pointer === null || event.pointerId !== pointer) return;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      if (!dragging) {
        if (!swipeable) {
          if (Math.abs(dx) > 4 || Math.abs(dy) > 4) moved = true;
          return;
        }
        if (Math.abs(dx) < 8 || Math.abs(dx) <= Math.abs(dy)) return;
        dragging = true;
        moved = true;
        root.setAttribute("data-xg-deck-drag", "");
        if (root.setPointerCapture) {
          try { root.setPointerCapture(pointer); } catch (e) {   }
        }
      }
      cards[at].style.setProperty("--xg-deck-dx", dx + "px");
    });
    function release(event) {
      if (pointer === null || (event && event.pointerId !== pointer)) return;
      var dx = event ? event.clientX - startX : 0;
      pointer = null;
      root.removeAttribute("data-xg-deck-drag");
      if (!dragging) return;
      dragging = false;
      var threshold = Math.max(44, root.clientWidth * 0.1);
      if (dx <= -threshold) go(1);
      else if (dx >= threshold) go(-1);
      else paint();
    }
    root.addEventListener("pointerup", release);
    root.addEventListener("pointercancel", release);
    root.addEventListener("keydown", function (event) {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      if (event.key === "ArrowRight") go(1);
      else if (event.key === "ArrowLeft") go(-1);
      else return;
      event.preventDefault();
    });
    if (prev) prev.addEventListener("click", function () { go(-1); });
    if (next) next.addEventListener("click", function () { go(1); });
    for (var k = 0; k < jumps.length; k += 1) {
      (function (btn) {
        btn.addEventListener("click", function () {
          to(parseInt(btn.getAttribute("data-xg-deck-to"), 10) || 0);
        });
      })(jumps[k]);
    }
    root.xgDeckShow = function (card) {
      var i = cards.indexOf(card);
      if (i < 0 || i === at) return;
      at = i;
      paint();
    };
    track.scrollLeft = 0;
    if (nav) nav.hidden = false;
    if (index && jumps.length) index.hidden = false;
    root.setAttribute("data-xg-deck-ready", "");
    paint();
  }
  function init(scope) {
    prune();
    var roots = (scope || doc).querySelectorAll("[data-xg-deck]");
    for (var i = 0; i < roots.length; i += 1) {
      var root = roots[i];
      if (root.hasAttribute("data-xg-deck-ready")) continue;
      build(root);
      if (root.hasAttribute("data-xg-deck-ready")) decks.push(root);
    }
  }
  init(doc);
  doc.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
  doc.addEventListener("shopify:section:unload", prune);
  doc.addEventListener("shopify:block:select", function (event) {
    prune();
    for (var i = 0; i < decks.length; i += 1) {
      if (!decks[i].contains(event.target)) continue;
      var card = event.target.closest(".xg-founder__card");
      if (card && decks[i].xgDeckShow) decks[i].xgDeckShow(card);
      return;
    }
  });
  window.XG = window.XG || {};
  window.XG.founder = {
    init: init,
    live: function () { prune(); return decks.length; }
  };
})();
